import { render, staticRenderFns } from "./authResult.vue?vue&type=template&id=33008a22&scoped=true"
import script from "./authResult.vue?vue&type=script&lang=js"
export * from "./authResult.vue?vue&type=script&lang=js"
import style0 from "./authResult.vue?vue&type=style&index=0&id=33008a22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33008a22",
  null
  
)

export default component.exports